import './index.scss'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform'
import { track } from 'cm'

import { axios, FixHeader } from 'cm'
// import axios from 'axios';
import config from './config'
import md5 from 'md5'
import './audio'
import VipLock from 'src/public-resource/components/VipLock'
// import  vconsole from 'vconsole';
import './module/reportEntry'

import { wxOpenApp } from '../../../frontend-lib/component/wxToAPP'
import { Base64 } from 'js-base64'

class hotSowingFM {
  constructor() {
    this.data = {
      token: '',
      audioObj: {}
    }
    this.init()
  }
  init() {
    // var vConsole = new vconsole();
    // setHeader(config.headerConfig);
    new FixHeader(config.headerConfig)
    window.showToast = function(params) {
      clearTimeout(window.timeout)
      if (typeof params !== 'object') {
        params = {
          text: params
        }
      }
      let message = params.text || '加载中...'
      window.timeout = setTimeout(function() {
        $('.toast').html(message)
        $('.toast-wrap').css('display', 'flex')
        var newParams = {
          delay: params.time,
          callFn: params.callFn || null
        }
        window.closeToast(newParams)
      }, params.delay || 200)
    }
    window.closeToast = function(params) {
      if (typeof params !== 'object') {
        params = {
          delay: params
        }
      }
      clearTimeout(window.timeout)
      clearTimeout(window.timeoutClose)
      window.timeoutClose = setTimeout(function() {
        params.callFn && params.callFn()
        $('.toast-wrap').css('display', 'none')
      }, params.delay || 1000)
    }
    var that = this
    window.startNum = 0
    this.eventInit()
    window.getStyle = this.getStyle
    window.changAudioMes = this.changAudioMes
    window.imgleft = this.imgleft
    window.GetRequest = this.GetRequest
    window.axios = axios
    //  获取token

    axios
      .get(window.location.origin + '/ajax/get-user-header', {
        params: {}
      })
      .then(res => res.data)
      .then(res => {
        if (res.data.user && res.data.user.token) {
          that.data.token = res.data.user.token
        }
      })
      .catch(function(error) {})
    // 识别终端
    var UAobj = getPlatform()
    if (UAobj.isPc) {
      var shareElm = document.getElementsByClassName(
        'yxl-font-retransmission'
      )[0]
      shareElm.parentNode.removeChild(shareElm)
    }
    // 分享功能
    var audioId
    if (window.location.href.indexOf('fm/trend/') >= 0) {
      audioId = window.location.href.split('fm/trend/')[1].split('?')[0]
    } else if (window.location.href.indexOf('fm/') >= 0) {
      audioId = window.location.href.split('fm/')[1].split('?')[0]
    }
    if (isNaN(audioId)) {
      audioId = $('#img-div li')
        .eq(window.startNum)
        .attr('data-id')
    }
    var shareBtn = document.getElementsByClassName('share')[0]
    shareBtn.onclick = function() {
      var params = that.GetRequest()
      if (UAobj.isWechat) {
        window.showToast('请点击右上角分享给朋友')
      } else if (!UAobj.isPc && !UAobj.isWechat) {
        var copyText =
          window.location.protocol +
          '//' +
          window.location.host +
          '/fm/share/' +
          audioId
        var save = function(e) {
          e.clipboardData.setData('text/plain', copyText)
          e.preventDefault()
        }
        document.addEventListener('copy', save)
        document.execCommand('copy')
        window.showToast('复制链接成功，快去分享吧')
      }
    }
    // 跳APP
    let fmId = window.baseInfo.more_themes_url.split('/')[2]
    if (fmId.indexOf('?') >= 0) {
      fmId = fmId.slice(
        0,
        window.baseInfo.more_themes_url.split('/')[2].indexOf('?')
      )
    }
    const link = `yixinli://open_broadcast?id=${fmId}`
    const AppHref = `yixinli://open_native?url=${Base64.encodeURI(link)}`
    let goAppElement = `<div
      class="wxOpenInAPP"
      style="position: absolute;width: 100%;height: 100%;left: 0;top: 0;z-index: 2;display: ${
        UAobj.isWechat ? 'block' : 'none'
      }"
      data-url="${link}"
      data-type="act"
    > </div>`
    $('#downloadBtn').append(goAppElement)
    var downloadBtn = document.getElementById('downloadBtn')
    downloadBtn.addEventListener('click', function() {
      track.trackEvent('fm_details_appdownloadbutton', {})
      window.location.href = AppHref
    })

    track.trackPageView('fm_details_view', {
      fm_id: fmId || ''
    })
  }
  shareEvent() {
    var anchor = $('#img-div li')
      .eq(window.startNum)
      .attr('data-title')
    var cover = $('.img-div li')
      .eq(window.startNum)
      .css('background-image')
      .replace(/^url\("/g, '')
      .replace(/"\)/g, '')
    // var cover = $('.img-div li').eq(window.startNum).css('background-image').split('url("')[1].split('")')[0];
    var params = this.GetRequest()
    var audioId
    if (window.location.href.indexOf('fm/trend/') >= 0) {
      audioId = window.location.href.split('fm/trend/')[1].split('?')[0]
    } else if (window.location.href.indexOf('fm/') >= 0) {
      audioId = window.location.href.split('fm/')[1].split('?')[0]
    }
    if (isNaN(audioId)) {
      audioId = $('#img-div li')
        .eq(window.startNum)
        .attr('data-id')
    }
    window.wx_share_config = {
      url:
        window.location.protocol +
        '//' +
        window.location.host +
        '/fm/share/' +
        audioId,
      covor: cover,
      title: anchor,
      desc: $('.FM-decrition-b span').html()
    }
    // 判断环境
    var HOST = getRunTime('//m.xinli001.com')
    function getRunTime(link) {
      var result
      var _href = window.location.href.split('.')[0]

      _href.replace(/-([A-Za-z0-9]*)/, function(s, v) {
        result = link.replace(/\./, '-' + v + '.')
      })
      if (!result) {
        result = link
      }
      return result
    }
    // 微信分享
    if (window.$platform.isWechat) {
      var currentUrl = document.location.href
      var getWxConfig = `${HOST}/wx/get-wx-package.json`
      axios
        .get(
          getWxConfig + '?url=' + encodeURIComponent(currentUrl) + '&name=yida'
        )
        .then(res => {
          if (res.data.code == 0) {
            var wxConfig = res.data.data
            function loadScript(url, callback) {
              var script = document.createElement('script')
              script.type = 'text/javascript'
              if (typeof callback !== 'undefined') {
                if (script.readyState) {
                  script.onreadystatechange = function() {
                    if (
                      script.readyState == 'loaded' ||
                      script.readyState == 'complete'
                    ) {
                      script.onreadystatechange = null
                      callback()
                    }
                  }
                } else {
                  script.onload = function() {
                    callback()
                  }
                }
              }
              script.src = url
              document.body.appendChild(script)
            }
            setTimeout(() => {
              loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
                var _config = {
                  debug: wxConfig.debug,
                  appId: wxConfig.appId,
                  timestamp: wxConfig.timestamp,
                  nonceStr: wxConfig.nonceStr,
                  signature: wxConfig.signature,
                  jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo',
                    'onMenuShareQZone',
                    'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                    'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                  ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                  openTagList: ['wx-open-launch-app']
                }

                // 微信基本配置信息
                wx.config(_config)
                wx.ready(function() {
                  // var shareConfig = {
                  //     title: '壹心理',
                  //     desc: '壹心理',
                  //     link: window.location.href,
                  //     imgUrl: 'https://ossimg.xinli001.com/20180320/5c70531946c8ab1a792cbec044534cd9.jpg',
                  //     success: function(res) {},
                  //     cancel: function(res) {},
                  //     fail: function(res) {}
                  // };
                  // let tempConfig = window.baseInfo.wx_share_config;
                  var tempConfig = window.wx_share_config
                  tempConfig.imgUrl = tempConfig.cover
                  tempConfig.link = tempConfig.url
                  var shareConfig = tempConfig
                  // 分享到朋友圈
                  wx.onMenuShareTimeline(shareConfig)
                  // 分享给朋友
                  // wx.onMenuShareAppMessage(shareConfig);
                  wx.onMenuShareAppMessage({
                    title: anchor, // 分享标题
                    desc: $('.FM-decrition-b span').html(), // 分享描述
                    link:
                      window.location.protocol +
                      '//' +
                      window.location.host +
                      '/fm/share/' +
                      audioId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: cover, // 分享图标
                    type: 'video', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function() {
                      // 用户点击了分享后执行的回调函数
                    }
                  })
                  // 分享到QQ
                  wx.onMenuShareQQ(shareConfig)
                  // 分享到腾讯微博
                  wx.onMenuShareWeibo(shareConfig)
                  // 分享到QQ空间
                  wx.onMenuShareQZone(shareConfig)
                  wx.updateAppMessageShareData(shareConfig)
                  wx.updateTimelineShareData(shareConfig)
                })
                wxOpenApp.init()
              })
            }, 500)
          }
        })
    }
  }
  zhugeEvent() {}
  headerEvent() {}
  getStyle(obj, attr) {
    if (obj.currentStyle) {
      return obj.currentStyle[attr]
    } else {
      return window.getComputedStyle(obj, false)[attr]
    }
  }
  changUrl(e) {
    var baseUrl = window.location.href.split('?')[0]
    var objImg = document.getElementById('img-div')
    var liList = objImg.getElementsByTagName('li')
    var anchor = document
      .getElementsByClassName('FM-decrition-b')[0]
      .getElementsByTagName('span')[0].innerHTML
    var searchParams = this.GetRequest()
    searchParams['audio_id'] = window.idArr[e].id
    searchParams['page'] = window.idArr[e].page
    window.audio_page = window.idArr[e].page
    if (searchParams['collection']) {
      delete searchParams['collection']
    }
    var searchValue = ''
    for (var o in searchParams) {
      if (searchParams[o] != -1) {
        searchValue += o + '=' + searchParams[o] + '&'
      }
    }
    searchValue = searchValue.substring(0, searchValue.length - 1)
    var newUrl = baseUrl + '?' + searchValue
    if (window.history.pushState) {
      window.history.pushState(null, null, newUrl)
    }
    this.shareEvent()
  }
  imgleft(e) {
    if (window.startNum + 1 >= $('#img-div li').length) {
      window.showToast('没有更多了')
      return false
    }
    var objImg = document.getElementById('img-div')
    var liList = objImg.getElementsByTagName('li')
    var runWidth =
      parseFloat(window.getStyle(liList[0], 'left')) -
      parseFloat(window.getStyle(liList[1], 'left'))
    if (window.startNum !== liList.length - 1) {
      window.startNum++
      for (var j = 0; j < liList.length; j++) {
        liList[j].style.display = 'block'
        liList[j].style.left =
          parseFloat(window.getStyle(liList[j], 'left')) + runWidth + 'px'
        liList[j].style.transform = 'scaleY(0.85)'
      }
      liList[window.startNum].style.transform = 'scale(1)'
      // window.changAudioMes(window.startNum);
    }
    if (e) {
      // window.audioFn.switch(true);
    }
    var urlTimer = setTimeout(function() {
      window.location.href = $('#img-div li')
        .eq(window.startNum)
        .attr('data-url')
      clearTimeout(urlTimer)
    }, 500)
  }
  imgright(e) {
    if (window.startNum - 1 < 0) {
      window.showToast('没有更多了')
      return false
    }
    var objImg = document.getElementById('img-div')
    var liList = objImg.getElementsByTagName('li')
    var runWidth =
      parseFloat(window.getStyle(liList[0], 'left')) -
      parseFloat(window.getStyle(liList[1], 'left'))
    if (window.startNum !== 0) {
      window.startNum--
      for (var i = 0; i < liList.length; i++) {
        liList[i].style.display = 'block'
        liList[i].style.left =
          parseFloat(window.getStyle(liList[i], 'left')) - runWidth + 'px'
        liList[i].style.transform = 'scaleY(0.85)'
      }
      liList[window.startNum].style.transform = 'scale(1)'
      // window.changAudioMes(window.startNum);
    }
    if (e) {
      // window.audioFn.switch(false);
    }
    var urlTimer = setTimeout(function() {
      window.location.href = $('#img-div li')
        .eq(window.startNum)
        .attr('data-url')
      clearTimeout(urlTimer)
    }, 500)
  }
  changAudioMes(i) {
    var ulObj = document.getElementById('img-div').getElementsByTagName('ul')[0]
    var liList = ulObj.getElementsByTagName('li')
    var collectionNum = parseInt(liList[i].getAttribute('data-collection'))
    var is_collect = liList[i].getAttribute('data-is_collect')
    var diantai_url = liList[i].getAttribute('data-diantai_url')
    var collectionElemt = document.getElementsByClassName('collection')[0]
    // var bgDiv = document.getElementsByClassName('bg-div')[0].getElementsByTagName('img')[0];
    // var newImgSrc = liList[i].style.backgroundImage.replace(/^url\("/g, '').replace(/"\)/g, '') + '?' + (Math.random() * 10);
    var newImgSrc = $('#img-div li')
      .eq(window.startNum)
      .css('background-image')
      .replace(/^url\(/g, '')
      .replace(/\)/g, '')
      .replace(/"/g, '')
    // var newImgSrc = liList[i].style.backgroundImage.split('url("')[1].split('")')[0];
    $('.bg-div img').prop('src', newImgSrc)
    for (var j = 0; j < liList.length; j++) {
      liList[j].classList.remove('active')
    }
    liList[i].classList.add('active')
    var newTitle =
      '<p>' +
      liList[i].getAttribute('data-title') +
      '</p>' +
      '<p>' +
      liList[i].getAttribute('data-title') +
      '</p>'
    $('.FM-decrition-t').html(newTitle)
    if ($('.FM-decrition-t p').width() > $('.FM-decrition-t').width()) {
      var Pwidth = parseInt($('.FM-decrition-t p').width())
      $('.FM-decrition-t p')
        .eq(1)
        .css('left', Pwidth + 60)
      var runTimer
      // var runTitle = function (){
      //   $('.FM-decrition-t p').stop(true).animate({'right': $('.FM-decrition-t p').width() }, 15000, 'linear', function() {
      //     $('.FM-decrition-t p').css('right', '0');
      //     clearTimeout(titleTimer);
      //     var titleTimer = setTimeout(runTitle, 1000)
      //   })
      // }
      // runTitle()
      var runTitleFn = function() {
        $('.FM-decrition-t p').each(function(index, e) {
          var rigthNum = parseFloat($(e).css('left'))
          if (index == 1 && rigthNum == 0) {
            $('.FM-decrition-t p')
              .eq(1)
              .css('left', Pwidth + 60 + 'px')
            $('.FM-decrition-t p')
              .eq(0)
              .css('left', '0')
            clearInterval(runTimer)
            clearTimeout(timerout)
            var timerout = setTimeout(function() {
              runTimer = setInterval(runTitleFn, 20)
            }, 1000)
            return false
          } else {
            var newValue = rigthNum - 1
            $(e).css('left', newValue)
          }
        })
      }
      var runtimerout = setTimeout(function() {
        runTimer = setInterval(runTitleFn, 20)
        clearTimeout(runtimerout)
      }, 3000)
    } else {
      $('.FM-decrition-t').html(liList[i].getAttribute('data-title'))
    }
    document
      .getElementsByClassName('FM-decrition-b')[0]
      .getElementsByTagName('span')[0].innerHTML =
      '主播：' + liList[i].getAttribute('data-anchor')
    document
      .getElementsByClassName('FM-decrition-b')[0]
      .getElementsByTagName('a')[0]
      .setAttribute('href', diantai_url)
    if (collectionNum > 999) {
      collectionNum = 999 + '+'
    }
    if (is_collect === '1') {
      collectionElemt
        .getElementsByTagName('i')[0]
        .classList.remove('yxl-font-likes')
      collectionElemt
        .getElementsByTagName('i')[0]
        .classList.add('yxl-font-like')
      collectionElemt
        .getElementsByTagName('i')[0]
        .setAttribute('data-id', window.idArr[i].id)
      collectionElemt.getElementsByTagName('span')[0].innerHTML = ''
    } else {
      collectionElemt
        .getElementsByTagName('i')[0]
        .classList.add('yxl-font-likes')
      collectionElemt
        .getElementsByTagName('i')[0]
        .classList.remove('yxl-font-like')
      collectionElemt
        .getElementsByTagName('i')[0]
        .setAttribute('data-id', window.idArr[i].id)
      collectionElemt.getElementsByTagName('span')[0].innerHTML = collectionNum
      collectionElemt.getElementsByTagName('span')[0].style.display = 'inline'
    }
    // window.changUrl(i);
  }
  imgRunEvent() {
    // 图片轮播
    var objImg = document.getElementById('img-div')
    var liList = objImg.getElementsByTagName('li')
    var startX
    var endX
    function delectLi(value, mod) {
      for (var j = 0; j < liList.length; j++) {
        if (mod === 1 && j >= value) {
          liList[j].parentNode.removeChild(liList[j])
        } else if (mod === 0 && j <= value) {
          liList[j].parentNode.removeChild(liList[j])
        }
      }
    }
    var runStatus = true
    if (liList.length > 1) {
      var runWidth =
        parseFloat(this.getStyle(liList[0], 'left')) -
        parseFloat(this.getStyle(liList[1], 'left'))
    }
    objImg.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX
    })
    objImg.addEventListener('touchmove', e => {})
    objImg.addEventListener('touchend', e => {
      if (!runStatus) {
        return false
      }
      runStatus = false
      // if ($('.img-div li').length === 1) {
      //   return false;
      // }
      endX = e.changedTouches[0].clientX
      var runValue = endX - startX
      if (runValue > 50) {
        this.imgright(true)
      } else if (runValue < -50) {
        // 左边移动
        this.imgleft(true)
      }
      var timer = setTimeout(() => {
        runStatus = true
        clearTimeout(timer)
      }, 500)
    })
  }
  GetRequest() {
    var url = location.search
    var theRequest = new Object()
    if (url.indexOf('?') != -1) {
      var str = url.substr(1)
      var strs = str.split('&')
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
      }
    }
    return theRequest
  }
  collectionEvent() {
    var that = this
    var collectionBtn = document
      .getElementsByClassName('collection')[0]
      .getElementsByTagName('i')[0]
    var toastDivObj = document.getElementsByClassName('toast-wrap')[0]
    var toastObj = document.getElementsByClassName('toast')[0]
    var paramsObj = window.GetRequest()
    var timestamp = new Date().getTime()
    function getRequestSign(
      params = {},
      apiSecret = '6767790dfc5c34d32e250ea3e9104910'
    ) {
      var arr = []
      var timestamp = params['timestamp']
      if (params['timestamp']) {
        params = omit(params, 'timestamp')
      }

      // 字典按key的字母顺序
      var keys = Object.keys(params).sort()
      var paramsStr = ''

      // 所有参数名和参数值按顺序拼接一起
      keys.map(key => {
        paramsStr = `${paramsStr}${key}=${params[key]},`
      })

      // 拼接apiSecret
      paramsStr = `${paramsStr}${timestamp}${apiSecret}`
      // console.log(md5);

      // md5加密
      var sign = md5(paramsStr) // 小写
      return sign
    }

    // lodash.omit的代替品
    function omit(obj, keys) {
      var result = {}
      var key

      for (key in obj) {
        if (keys.indexOf(key) == -1) result[key] = obj[key]
      }

      return result
    }
    // that.data.token = 'b291fc2364e42b5613228d81faa43456';
    if (that.data.token) {
      toastObj.innerHTML = '操作中...'
      toastDivObj.style.display = 'flex'
      // axios.get('https://yiapi-box4.xinli001.com/fm/v5/favorite.json', {
      // // 'https://yiapi-box4.xinli001.com/fm/v5/favorite.json'
      var param = {
        token: that.data.token,
        timestamp: timestamp,
        id: window.idArr[window.startNum].id,
        _platform: 'ios'
      }
      var sign = getRequestSign(param)
      axios
        .get(window.baseInfo.fm_favorite_url, {
          params: {
            token: that.data.token,
            timestamp: timestamp,
            id: window.idArr[window.startNum].id,
            sign: sign,
            _platform: 'ios'
          }
        })
        .then(res => res.data)
        .then(function(res) {
          var timer
          if (parseInt(res.data.is_fav) === 1) {
            // 已收藏
            collectionBtn.classList.remove('yxl-font-likes')
            collectionBtn.classList.add('yxl-font-like')
            document
              .getElementsByClassName('collection')[0]
              .getElementsByTagName('span')[0].style.display = 'none'
            window.showToast('收藏成功')
            $('.img-div ul li')
              .eq(window.startNum)
              .attr('data-is_collect', '1')
          } else if (parseInt(res.data.is_fav) === 0) {
            collectionBtn.classList.add('yxl-font-likes')
            collectionBtn.classList.remove('yxl-font-like')
            document
              .getElementsByClassName('collection')[0]
              .getElementsByTagName('span')[0].style.display = 'inline'
            var colletionNum = $('.img-div ul li')
              .eq(window.startNum)
              .attr('data-collection')
            if (colletionNum > 999) {
              colletionNum = '999+'
            }
            document
              .getElementsByClassName('collection')[0]
              .getElementsByTagName('span')[0].innerHTML = colletionNum
            window.showToast('已取消收藏')
            $('.img-div ul li')
              .eq(window.startNum)
              .attr('data-is_collect', '0')
          }
        })
        .catch(function(error) {
          // toastObj.innerHTML = '服务器错误';
          // var timer = setTimeout(() => {
          //   toastDivObj.style.display = 'none';
          //   clearTimeout(timer);
          // }, 1000);
        })
    } else {
      window.showToast({
        text: '未登录，稍后为您跳转到登录页面',
        callFn: function() {
          toastDivObj.style.display = 'none'
          // 'http://m-box4.xinli001.com/account/login';
          if (window.location.href.indexOf('?') < 0) {
            window.location.href =
              window.baseInfo.login_jump_url +
              '?next=' +
              encodeURIComponent(window.location.href + '?collection=true')
          } else {
            window.location.href =
              window.baseInfo.login_jump_url +
              '?next=' +
              encodeURIComponent(window.location.href + '&collection=true')
          }
        }
      })
    }
  }
  audioEvent() {
    var that = this
    window.onload = function() {
      window.errorList = []
      // var window_font = parseFloat($('html').css('font-size'));
      var window_height = $('html').height()
      var content_height = $('.content').height()
      var top_height = $('.top-div').height()
      var bottom_height = $('.bottom-download-app').height()
      if (bottom_height + top_height + content_height < window_height) {
        $('.bottom-download-app').css({ position: 'fixed', 'margin-top': '0' })
        // $('.content').css({'position': 'absolute', 'top': '50%', 'margin-top': -0.5 * content_height});
      } else {
        $('.bottom-download-app').css({
          position: 'relative',
          'margin-top': '35px'
        })
      }
      window.onresize = function() {
        var window_height = $('html').height()
        var content_height = $('.content').height()
        var top_height = $('.top-div').height()
        var bottom_height = $('.bottom-download-app').height()
        if (bottom_height + top_height + content_height < window_height) {
          $('.bottom-download-app').css({
            position: 'fixed',
            'margin-top': '0'
          })
          // $('.content').css({'position': 'absolute', 'top': '50%', 'margin-top': -0.5 * content_height});
        } else {
          $('.bottom-download-app').css({
            position: 'relative',
            'margin-top': '35px'
          })
          // $('.content').css({'position': 'static', 'top': '0', 'margin-top': '0'});
        }
      }
      var ulObj = document
        .getElementById('img-div')
        .getElementsByTagName('ul')[0]
      var oldLiArrObj = ulObj.getElementsByTagName('li')
      if (oldLiArrObj.length === 1) {
        // $('.prev').remove();
        // $('.next').remove();
      } else {
        var runWidth =
          parseFloat(that.getStyle(oldLiArrObj[0], 'left')) -
          parseFloat(that.getStyle(oldLiArrObj[1], 'left'))
      }
      var firstLiLeft = parseFloat(that.getStyle(oldLiArrObj[0], 'left'))
      var setConfig = {
        song: [],
        error: function(meg) {
          $('.playIcon')
            .removeClass('yxl-font-fm-pause')
            .addClass('yxl-font-fm-play')
          window.showToast({
            text: meg.meg,
            time: 1500,
            callFn: function() {
              $('.playIcon')
                .removeClass('yxl-font-fm-pause')
                .addClass('yxl-font-fm-play')
            }
          })
        },
        imgleft: that.imgleft,
        imgright: that.imgright,
        songSelect: 0
      }
      var paramsObj = that.GetRequest()
      var audioId
      if (window.location.href.indexOf('fm/trend/') >= 0) {
        audioId = window.location.href.split('fm/trend/')[1].split('?')[0]
      } else if (window.location.href.indexOf('fm/') >= 0) {
        audioId = window.location.href.split('fm/')[1].split('?')[0]
      }
      // 自动执行收藏功能
      if (paramsObj['collection']) {
        window.showToast({
          text: '操作中...'
        })
        var collectionTimer = setTimeout(() => {
          that.collectionEvent()
          this.clearTimeout(collectionTimer)
        }, 1000)
      }
      function testIdArr(e) {
        var list = window.idArr
        for (var i in list) {
          if (list[i].id === e.id) {
            return list[i]
            break
          }
        }
        return e
      }
      function initLi(e) {
        var newLiArrObj = ulObj.getElementsByTagName('li')
        var paramsObj = that.GetRequest()
        var newIdArr = []
        var newList = []
        for (var i = 0; i < newLiArrObj.length; i++) {
          var newObj = {}
          var newIdObj = {}
          newObj.title = newLiArrObj[i].getAttribute('data-title')
          newObj.src = newLiArrObj[i].getAttribute('data-src')
          newObj.platformLock =
            +newLiArrObj[i].getAttribute('data-selected') &&
            !window.baseInfo.isExchange
          newIdObj.id = newLiArrObj[i].getAttribute('data-id')
          // if (e === 0) {
          //   newIdObj.page = parseInt(window.audio_page) - 1;
          // } else if (e === 1) {
          //   newIdObj.page = parseInt(window.audio_page) + 1;
          // } else {
          //   if (!parseInt(paramsObj.page)) {
          //     newIdObj.page = 1;
          //     window.audio_page = 1;
          //   } else {
          //     window.audio_page = paramsObj.page;
          //     newIdObj.page = paramsObj.page;
          //   }
          // }
          newIdArr.push(testIdArr(newIdObj))
          newList.push(newObj)
          newObj = null
          newIdObj = null
        }
        window.idArr = newIdArr
        var indexValue = null
        if (audioId) {
          for (var j = 0; j < window.idArr.length; j++) {
            if (window.idArr[j].id == audioId) {
              indexValue = j
            }
          }
        } else {
          indexValue = 1
        }
        if (indexValue === null) {
          indexValue = 0
        } else if (newLiArrObj.length === 1) {
          indexValue = 0
        }
        changeLi(indexValue)
        changAudioMes(indexValue)
        if (window.audioFn) {
          window.audioFn.changeAudioList(newList)
        } else {
          setConfig.song = newList
        }
        that.shareEvent()
      }
      function changeLi(indexValue) {
        var newLiArrObj = ulObj.getElementsByTagName('li')
        for (var k = 0; k < newLiArrObj.length; k++) {
          newLiArrObj[k].style.transform = 'scaleY(0.85)'
          if (k === indexValue) {
            window.startNum = k
            if (window.audioFn) {
              window.audioFn.changeSelect(k)
            } else {
              setConfig.songSelect = k
            }
            newLiArrObj[k].style.left = firstLiLeft + 'px'
            newLiArrObj[k].style.transform = 'scaleY(1)'
          } else if (k < indexValue) {
            newLiArrObj[k].style.left =
              parseFloat(firstLiLeft) + (indexValue - k) * runWidth + 'px'
          } else if (k > indexValue) {
            newLiArrObj[k].style.left =
              parseFloat(firstLiLeft) - (k - indexValue) * runWidth + 'px'
          }
          newLiArrObj[k].style.display = 'block'
        }
      }
      window.initLi = initLi
      initLi()
      window.vipLock = new VipLock({
        audioId,
        isSelected: window.baseInfo.isSelected,
        userVip: window.baseInfo.userVip,
        isExchange: window.baseInfo.isExchange,
        callback() {
          setConfig.song[setConfig.songSelect].platformLock = false
        }
      })
      if (setConfig.song.length !== 0) {
        window.audioFn = null
        window.audioFn = new audioPlay(setConfig)
      }
      if (window.audioFn) {
        // 开始加载音频,true为播放,false不播放
        window.audioFn.loadFile(false)
      }
      // 监听dom变化
      ulObj.addEventListener('DOMNodeInserted', initLi)
      // 收藏功能
      var collectionBtn = document.getElementsByClassName('collection')[0]
      collectionBtn.addEventListener('click', () => {
        that.collectionEvent()
      })
    }
  }
  eventInit() {
    this.headerEvent()
    this.zhugeEvent()
    this.imgRunEvent()
    this.audioEvent()
  }
}

new hotSowingFM()



// WEBPACK FOOTER //
// ./src/pages/fm/hotSowingFM/index.js